module.exports = __webpack_public_path__ + "static/media/caretUp.c3f0da44.svg";